import { useEffect } from "react";
import { logEvent } from "firebase/analytics";
import { analytics } from "../firebase";
import {
  trackWebinarRegistration,
  trackWebinarView,
} from "../Utils/FacebookPixelUtils";

const useWebinarAnalytics = (webinarDetail, options = {}) => {
  const { source = "authenticated", isAuthenticated = true } = options;

  useEffect(() => {
    if (webinarDetail?.id) {
      logEvent(analytics, "view_item", {
        item_id: webinarDetail.id,
        item_name: webinarDetail.title,
        item_category: webinarDetail.category,
        content_type: "webinar",
        source,
        is_authenticated: isAuthenticated,
      });

      trackWebinarView(webinarDetail);
    }
  }, [webinarDetail, source, isAuthenticated]);

  const trackRegistration = (formData = {}) => {
    if (!webinarDetail?.id) return;

    const analyticsParams = {
      webinar_id: webinarDetail.id,
      webinar_title: webinarDetail.title,
      webinar_category: webinarDetail.category,
      webinar_date: webinarDetail.date || webinarDetail.scheduledAt,
      user_name: formData.name,
      user_organization: formData.organization,
      user_industry: formData.industry?.value || formData.industry,
      user_job_title: formData.jobTitle,
      source,
    };

    logEvent(analytics, "webinar_registration", analyticsParams);
    trackWebinarRegistration(webinarDetail, formData);
  };

  return { trackRegistration };
};

export default useWebinarAnalytics;
